import { defineStore } from "pinia";

export const useTabsStore = defineStore("tabs", {
  state: () => ({
    tabs: [],
  }),

  actions: {
    addTab(route) {
      if (!route?.path || route.meta?.hideTab) {
        return;
      }

      const exists = this.tabs.some((tab) => tab.path === route.path);

      if (exists) {
        return;
      }

      this.tabs.push({
        title: route.meta?.title || route.name || route.path,
        path: route.path,
        icon: route.meta?.icon || "",
        closable: this.tabs.length > 0,
      });
    },

    closeTab(path, activePath) {
      if (this.tabs.length <= 1) {
        return activePath;
      }

      const index = this.tabs.findIndex((tab) => tab.path === path);

      if (index === -1) {
        return activePath;
      }

      this.tabs.splice(index, 1);

      if (path !== activePath) {
        return activePath;
      }

      return this.tabs[index]?.path || this.tabs[index - 1]?.path || activePath;
    },

    resetTabs() {
      this.tabs = [];
    },
  },
});
